module.exports = __webpack_public_path__ + "static/media/Team 5 - Ecolution.b4d7ac48.png";